import { Record } from 'immutable';

export default class MunicipalityRecord extends Record({
  id: undefined,
  name: undefined,
}) {
}
